
import SGSymbolComponent from "components/matrix/symbol/sg-symbol-component";
import {Signal} from "signals";
import ReelSpinner from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contracts/contract";
import Point from "slotworks/utils/geom/point";

export default class SGReelSpinner extends ReelSpinner {
    public screenShaking: Signal = new Signal();

    public anticipate(index: number, reelstrip: string[]): Contract<void> {
        this.screenShaking.dispatch();
        return super.anticipate(index, reelstrip);
    }

    public stopAnticipation(): void {
        if (this.anticipationAnimations) {
            for (const anticipationAnimation of this.anticipationAnimations) {
                if (anticipationAnimation) {
                    anticipationAnimation.stop();
                    anticipationAnimation.visible = false;
                }
                this.anticipationAnimations = null;
            }
        }
    }

    protected createSymbolComponent(position: Point, matrixLayer: Layers, animationLayer: Layers): SGSymbolComponent {
        return new SGSymbolComponent(position, matrixLayer, animationLayer);
    }

}
